<template>
    <div style="display:flex; flex-direction:column; justify-content:center; align-items:center;">
      <Header></Header>
      <HeaderSec Title="传统企业数字化-经典部署方案系列：Bluesolution-CT01" Desc="" :BreadcrumbList="BreadcrumbList"></HeaderSec>
      <Row style="padding:20px;" gutter="24" class="list">
          <Col :xs="22" :sm="22" :md="22" :lg="22" :xl="18" :xxl="18">
            <Card style="width:100%" :bordered="false" :dis-hover="true" :shadow="true">
              <template #title>
                <Title :level="5">
                  <Icon type="ios-film-outline"></Icon>
                  方案简介： Bluesolution-CT01
                </Title>
              </template>
              <div style="display: flex; flex-direction:row; justify-content:space-between;">
                <Typography>
                  <Paragraph>
                    <Title :level="6">物理层云化+备份容灾，支持横向扩容，全面支持性能突发，支持故障转移，提供高阶的系统可用性</Title>
                  </Paragraph>
                  <Paragraph>
                    <ul>
                        <li>应用采用分离部署结构，应用和数据库进行分离单独部署，按各种的特性以支持灵活的部署方式</li>
                        <li>提供两种以上的数据备份冗余方式，应对更广泛的数据风险</li>
                        <li>提供方案全生命周期的运维服务，使用无忧</li>
                        <li>高度集成，极高性价比</li>
                        <li>所有的方案，均可集成多一台 <router-link to="Blueiaas-LX5-HS101">Blueiaas-LX5-HS101(256GB版本)</router-link> 作为灾难降级备份点，约增加费用：<b>¥{{ Price['LX5-HS101'][0] }}</b></li>
                    </ul>
                  </Paragraph>
                </Typography>
                <Image src="https://www.bluehci.com/images001/solution001.png" fit="contain" width="270px" height="161px" alt="contain" />
              </div>
            </Card>
            <Card style="width:100%" :bordered="false" :dis-hover="true" :shadow="true" v-for="(value_FA, key) in data" :key="key">
              <template #title>
                <Title :level="5">
                  <Icon type="ios-medal-outline" />
                  {{ key }}
                </Title>
              </template>
              <Table :columns="columns" :data="value_FA" border show-summary :summary-method="handleSummary" :span-method="handleSpan">
                <template #link="{ row }">
                    <router-link :to="row.link.link">{{ row.link.title }}</router-link>
                </template>
                <template #desc="{ row }">
                  <Typography style="white-space: pre-line;">{{ row.desc }}</Typography>
                </template>
              </Table>
            </Card>
          </Col>
          <Col :xs="0" :sm="0" :md="0" :lg="0" :xl="6" :xxl="6">
            <BlueSolutionSideList></BlueSolutionSideList>
          </Col>
      </Row>
    </div>
</template>

<script>
import BlueSolutionSideList from '@/components/BlueSolution-sideList.vue'
import Header from '@/components/Header.vue'
import HeaderSec from '@/components/HeaderSec.vue'
import RPrice from '@/http/Price.js'
export default {
  name: 'BlueSolution-CT01',
  components: {
    BlueSolutionSideList,
    Header,
    HeaderSec,
  },
  setup() {
  },
  data(){
    let Price = RPrice.getPrice();
    return {
        BreadcrumbList: [
            {
                title: '首页',
                to: '/'
            },
            {
                title: '数字化IT咨询与运维',
                to: '/Bluesolution'
            },
            {
                title: 'BlueSolution-CT01'
            }
        ],
        Price: Price,
        columns: [
            {
                title: '物料链接',
                slot: 'link',
                width: 350,
            },
            {
                title: '物料数量',
                key: 'num',
                width: 100,
            },
            {
                title: '物料单价',
                key: 'price',
                width: 100,
            },
            {
                title: '方案说明',
                slot: 'desc',
            },
        ],
        data: {'方案A': [
            {
              link:{'title': 'Blueiaas-LX5-HS101(256GB版本)', 'link':'Blueiaas-LX5-HS101'},
              num:1,
              price: Price['LX5-HS101'][0],
              desc:`1. 高性价比方案，多核心，高算力，适合传统企业的ERP，OA，MES等系统
2. 独立数据库服务器，全闪阵列，全力加持数据库性能，同时也有raid5保护数据的可靠性
3. 在LX5-HL101上构建数据库备份文件服务器，并开启每日快照保护，在raid硬件保护的基础上增加勒索病毒等软件风险保护能力`,
            },
            {
              link:{'title': 'Blueiaas-LX5-ML021(阵列版)', 'link':'Blueiaas-LX5-ML021'},
              num:1,
              price: Price['LX5-ML021'][0],
              desc:"N/A"
            },
            {
              link:{'title': '蓝心数字化IT咨询与运维服务-等级二', 'link':'Bluesolution'},
              num:1,
              price:10000,
              desc:"N/A"
            },
          ],
          '方案B（推荐）': [
            {
              link:{'title': 'Blueiaas-LX5-HS101(256GB版本)', 'link':'Blueiaas-LX5-HS101'},
              num:1,
              price: Price['LX5-HS101'][0],
              desc:`1. 高性价比方案，多核心，高算力，适合传统企业的ERP，OA，MES等系统
2. 独立数据库服务器，PCIE的闪存卡设计，可达10倍常规ssd性能，全力加持数据库性能，但是缺少硬件数据保护
3. 在LX5-HL101上构建数据库备份文件服务器，并开启每日快照保护，弥补了该方案硬件数据可靠性保护的缺点，并具有勒索病毒等软件风险保护能力`,
            },
            {
              link:{'title': 'Blueiaas-LX5-ML021(阵列+闪存卡版本)', 'link':'Blueiaas-LX5-ML021'},
              num:1,
              price: Price['LX5-ML021'][1],
              desc:"N/A"
            },
            {
              link:{'title': '蓝心数字化IT咨询与运维服务-等级二', 'link':'Bluesolution'},
              num:1,
              price:10000,
              desc:"N/A"
            },
          ],
          '方案C': [
            {
              link:{'title': 'Blueiaas-LX5-HL302(256GB版本)', 'link':'Blueiaas-LX5-HL302'},
              num:1,
              price: Price['LX5-HL302'][0],
              desc:`1. 高性价比方案，高主频，适合传统企业的ERP，OA，MES等系统，相比《方案A》有更强的承载力，可以应对更多的使用人数和更多的系统（约可增加40%）
2. 独立数据库服务器，全闪阵列，全力加持数据库性能，同时也有raid5保护数据的可靠性
3. 在LX5-HL302上构建数据库备份文件服务器，并开启每日快照保护，在raid硬件保护的基础上增加勒索病毒等软件风险保护能力`,
            },
            {
              link:{'title': 'Blueiaas-LX5-ML022(阵列版本)', 'link':'Blueiaas-LX5-ML022'},
              num:1,
              price: Price['LX5-ML022'][0],
              desc:"N/A"
            },
            {
              link:{'title': '蓝心数字化IT咨询与运维服务-等级二', 'link':'Bluesolution'},
              num:1,
              price:10000,
              desc:"N/A"
            },
          ],
          '方案D（推荐）': [
            {
              link:{'title': 'Blueiaas-LX5-HL302(512GB版本)', 'link':'Blueiaas-LX5-HL302'},
              num:1,
              price: Price['LX5-HL302'][1],
              desc:`1. 高性价比方案，高主频，适合传统企业的ERP，OA，MES等系统，相比《方案C》有更强的承载力，可以应对更多的使用人数和更多的系统（约可增加20%）
2. 独立数据库服务器，全闪阵列，全力加持数据库性能，同时也有raid5保护数据的可靠性
3. 在LX5-HL302上构建数据库备份文件服务器，并开启每日快照保护，在raid硬件保护的基础上增加勒索病毒等软件风险保护能力`,
            },
            {
              link:{'title': 'Blueiaas-LX5-ML022(阵列版+闪存卡版本)', 'link':'Blueiaas-LX5-ML022'},
              num:1,
              price: Price['LX5-ML022'][1],
              desc:"N/A"
            },
            {
              link:{'title': '蓝心数字化IT咨询与运维服务-等级二', 'link':'Bluesolution'},
              num:1,
              price:10000,
              desc:"N/A"
            },
          ],
          '方案E（推荐）': [
            {
              link:{'title': 'Blueiaas-LX5-HP302(512GB版本)', 'link':'Blueiaas-LX5-HP302'},
              num:1,
              price: Price['LX5-HP302'][1],
              desc:`1. 高性价比方案，高主频，适合传统企业的ERP，OA，MES等系统，相比《方案D》在虚拟化上有更强的承载力，可以应对更多的使用人数和更多的系统（约可增加20%）
2. 独立数据库服务器，全闪阵列，全力加持数据库性能，同时也有raid5保护数据的可靠性
3. 在LX5-HP302上构建数据库备份文件服务器，并开启每日快照保护，在raid硬件保护的基础上增加勒索病毒等软件风险保护能力`,
            },
            {
              link:{'title': 'Blueiaas-LX5-ML022(阵列版+闪存卡版本)', 'link':'Blueiaas-LX5-ML022'},
              num:1,
              price: Price['LX5-ML022'][1],
              desc:"N/A"
            },
            {
              link:{'title': '蓝心数字化IT咨询与运维服务-等级二', 'link':'Bluesolution'},
              num:1,
              price:10000,
              desc:"N/A"
            },
          ],
        },
    }
  },
  methods: {
    handleSpan ({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0 && columnIndex === 3) {
            return [30, 1];
        }
    },
    handleSummary ({ columns, data }) {
        const sums = {};
        columns.forEach((column, index) => {
            const key = column.key;
            if (index === 0) {
                sums[key] = {
                    key,
                    value: '总计' };
                return;
            }
            const values = data.map(item => Number(item[key]));
            if (!values.every(value => isNaN(value))) {
                const v = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                }, 0);
                if (index === 2) {
                    sums[key] = {
                        key,
                        value: '¥ ' + v
                    };
                } else {
                    sums[key] = {
                        key,
                        value: v
                    };
                }
            } else {
                sums[key] = {
                    key,
                    value: ''
                };
            }
        });

        return sums;
    }
  }
}
</script>

<style lang="less" scoped>
.list{
  width: 90%;
}
@media (min-width: 1000px) {
  .list{
    width: 1600px;
  }
}
</style>
